"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseStyle = void 0;

var _styledComponents = require("styled-components");

var baseStyle = (0, _styledComponents.css)(["box-sizing:border-box;"]);
exports.baseStyle = baseStyle;